<template>
  <el-dialog title="收货地址" :visible.sync="dialogTableVisible" width="52.4%"
             :append-to-body="true"
             :close-on-click-modal="false">
    <template slot="title">
      <div class="add_goodmodel">添加商品模型</div>
    </template>

    <div class="search_box">
      <div class="left_search">
        <el-cascader
          v-model="value"
          :options="options"
          @change="handleChange"
          :props="{label:'name',value:'code',children:'list'}"
        ></el-cascader>
      </div>

      <el-input
        placeholder="请输入模型名称或编码"
        v-model="input_select"
        suffix-icon="el-icon-search"
        @change="InputSearch"
      ></el-input>

      <div class="model_num">模型数量：{{total}}个</div>
    </div>

    <ul class="model_ul">
      <li v-for="(item, index) in entities" :key="index">
        <div class="model_li">
          <img :src="item.thumbnail" class="model_img" alt/>
          <div class="model_info">
            <div class="model_info_top">
              <div class="model_title">{{item.name}}</div>
              <div class="model_time">{{item.uploadTime}}</div>
            </div>
            <div class="model_time">{{item.code}}</div>
          </div>
          <div class="bigBox">
            <div class="mouseEvent" @click="guanlianmoxing(index)" v-if="istrue">关联该模型</div>
          </div>
          <div class="public" v-if="item.publicX">公开</div>
        </div>
      </li>
    </ul>

    <div class="block">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page.sync="page"
        :page-size="size"
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
  </el-dialog>
</template>

<script>
  import moment from "moment";

  export default {

    data() {
      return {
        dialogTableVisible: false,
        istrue: true,
        input_select: "",
        page: 1,
        size: 12,
        total: 50,
        code: null,
        value: [],
        options: [],
        entities: []
      };
    },
    methods: {
      // 页数跳转事件
      handleCurrentChange(val) {
        // console.log(val)
        this.page = val;
        this.getModelPage();
      },
      // 下拉框查询
      handleChange(value) {
        this.code = value[1];
        this.getModelPage();
      },
      // 输入框查询
      InputSearch() {
        this.getModelPage();
      },
      // 获取模型列表
      getModelPage() {
        this.$axios
          .post(this.$url.getModelPage, {
            take: this.size,
            page: this.page,
            typeCode: this.code || null,
            keyword: this.input_select || null
          })
          .then(res => {
            this.total = res.data.count;
            this.entities = []
            if (res.data.entities) {
              this.entities = res.data.entities.map(_ => {
                _.uploadTime = _.uploadTime.split(" ")[0];
                return _;
              });
            }

          });
      },
      // 获取模型类型
      getModelTypeList() {
        this.$axios.get(this.$url.getModelTypeList).then(res => {
          this.options = res.data;
        });
      },
      // 关联该模型点击事件
      guanlianmoxing(index) {
        this.$emit('thumbnail', this.entities[index])
        this.dialogTableVisible = false
      },
      query(){
      this.dialogTableVisible = true
      this.getModelTypeList();
      this.getModelPage();
      } 
    },
    created() {
      
    }
  };
</script>

<style lang='less' scoped>
  .block {
    text-align: center;
  }

  .public {
    background: rgba(0, 176, 183, 1);
    color: #fff;
    position: absolute;
    top: 0;
    left: 5px;
    padding: 3px 5px;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }

  .model_ul {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;

    .model_li {
      width: 224px;
      height: 177px;
      margin-right: 15px;
      margin-bottom: 20px;
      position: relative;
      background: rgba(255, 255, 255, 1);
      box-sizing: border-box;
      border: 1px solid #f5f5f5;
      box-shadow: 0px 6px 23px 1px rgba(0, 0, 0, 0.1);

      &:hover {
        .bigBox {
          display: block;
        }
      }
    }

    .model_img {
      width: 224px;
      height: 124px;
      background: rgba(66, 60, 60, 1);
    }

    .model_info {
      height: 53px;
      box-sizing: border-box;
      width: 100%;
      padding: 5px 10px 0;
      box-sizing: border-box;
    }

    .model_info_top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 5px;
    }

    .model_title {
      width: 100px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 14px;
      margin-right: 10px;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
    }

    .model_time {
      font-size: 12px;
      color: rgba(153, 153, 153, 1);
    }
  }

  ::v-deep .el-dialog__body {
    padding-top: 10px !important;

    .search_box {
      display: flex;
      position: relative;
      margin-bottom: 10px;

      .model_num {
        position: absolute;
        right: 0;
        bottom: 0;
      }
    }
  }

  .left_search {
    width: 220px;
    margin-right: 150px;

    ::v-deep .el-input {
      width: 220px !important;
      margin-right: 0 !important;

      ::v-deep .el-input__inner {
        width: 220px !important;
      }
    }
  }

  .add_goodmodel {
    width: 144px;
    height: 35px !important;
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(72, 72, 72, 1);
  }

  .bigBox {
    position: absolute;
    top: 0;
    height: 124px;
    box-sizing: border-box;
    left: 0;
    right: 0;
    // background-color: pink;
    padding: 46px 56px;
    display: none;
  }

  .mouseEvent {
    cursor: pointer;
    width: 108px;
    height: 32px;
    display: flex;
    color: #fff;
    font-size: 14px;
    align-items: center;
    justify-content: center;
    background: rgba(0, 176, 183, 1);
    border-radius: 3px;
  }
</style>
